import { useState, useEffect } from 'react';

interface MenuImageSlideshowProps {
  category: string | null;
}

const categoryImages: Record<string, string[]> = {
  produse: [
    '/lovable-uploads/produse-video-1.mp4',
    '/lovable-uploads/produse-video-2.mp4',
  ],
  proiecte: [
    '/lovable-uploads/proiecte-video-1.mp4',
    '/lovable-uploads/proiecte-video-2.mp4',
  ],
  productie: [
    '/lovable-uploads/productie-video-1.mp4',
    '/lovable-uploads/productie-video-2.mp4',
  ],
  'unde-ne-gasesti': [
    '/lovable-uploads/unde-video-1.mp4',
    '/lovable-uploads/unde-video-2.mp4',
  ],
  contact: [
    '/lovable-uploads/contact-video-1.mp4',
  ],
};

const defaultImages = [
  '/lovable-uploads/menu-mobile-video-1.mp4',
  '/lovable-uploads/menu-mobile-video-2.mp4',
];

export default function MenuImageSlideshow({ category }: MenuImageSlideshowProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const images = category && categoryImages[category] ? categoryImages[category] : defaultImages;

  useEffect(() => {
    setCurrentIndex(0);
  }, [category]);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
        setIsTransitioning(false);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="relative w-full h-full overflow-hidden">
      {/* Vignette overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-black/20 via-transparent to-black/40 z-10 pointer-events-none" />
      
      {images.map((image, index) => (
        <div
          key={`${category}-${image}-${index}`}
          className={`absolute inset-0 transition-all duration-700 ease-in-out ${
            index === currentIndex && !isTransitioning 
              ? 'opacity-100 scale-100' 
              : 'opacity-0 scale-105'
          }`}
        >
          {image.endsWith('.mp4') ? (
            <video
              src={image}
              className="w-full h-full object-cover transition-transform duration-700 ease-in-out"
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
            />
          ) : (
            <img
              src={image}
              alt="Menu preview"
              className="w-full h-full object-cover transition-transform duration-700 ease-in-out"
              loading="lazy"
            />
          )}
        </div>
      ))}
    </div>
  );
}
